import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IFrotaPJ } from "../../../../interface/FrotaPJ";

export const FrotaPJ = (data: IFrotaPJ) => {
  return (
    <Panel header="Frota PJ" toggleable>
      <DataTable value={data?.veiculos} emptyMessage="Nada consta">
        <Column header="Placa" field="placa" />
        <Column header="Chassi" field="chassi" />
        <Column header="Renavam" field="renavam" />
        <Column header="Modelo" field="modelo" />
        <Column header="Cor" field="cor" />
        <Column header="Ano Fabricação" field="ano_fabricacao" />
        <Column header="Ano Modelo" field="ano_modelo" />
        <Column header="Motor" field="motor" />
        <Column header="Espécie" field="especie" />
        <Column header="UF" field="estado" />
      </DataTable>
    </Panel>
  );
};
